import * as yup from 'yup';
import {
  getPasswordStringValidator,
  getRequiredStringValidator,
} from './Generators';

export const emailAddressValidator = yup
  .string()
  .email('Email is not valid')
  .required('Required field')
  .max(75, 'Email must be 75 characters or less');

export const phoneNumberValidator = getRequiredStringValidator().matches(
  /^[\d\s+()\-*.#extn]{7,31}/g,
  'Enter a valid Phone Number'
);
export const passwordValidator = getRequiredStringValidator();
export const passwordLengthValidator = getPasswordStringValidator();
